<div class="d-flex flex-column mt-2">
  <ng-container
    *ngIf="
      smartAssistantFeedFilters.search == '' &&
      smartAssistantFeedFilters.userList == null &&
      smartAssistantFeedFilters.district == null &&
      smartAssistantFeedFilters.schoolList == [] &&
      smartAssistantFeedFilters.fromDate == null &&
      smartAssistantFeedFilters.toDate == null
    ">
    <div class="fs-15 text-center pt-3 pb-4">No filters applied</div>
  </ng-container>
  <div
    class="badge badge-item removable d-flex flex-row"
    *ngIf="smartAssistantFeedFilters.search"
    (click)="removeFilter('search')">
    <i class="bi bi-geo-alt me-1"></i>
    <div class="flex-grow-1">
      <span class="fw-800">Keyword:</span>
      {{ smartAssistantFeedFilters.search }}
    </div>
    <i class="bi bi-x d-block"></i>
  </div>
  <div
    class="badge badge-item removable d-flex flex-row"
    *ngIf="smartAssistantFeedFilters.district"
    (click)="removeFilter('district')">
    <i class="bi bi-geo-alt me-1"></i>
    <div class="flex-grow-1">
      <span class="fw-800"> District: </span
      ><app-district-name
        [districtId]="smartAssistantFeedFilters.district!.id" />
    </div>
    <i class="bi bi-x d-block"></i>
  </div>
  <ng-container *ngFor="let school of smartAssistantFeedFilters.schoolList">
    <div
      class="badge badge-item removable d-flex flex-row"
      (click)="removeFilterFromList('schools', school)">
      <i class="bi bi-building me-1"></i>
      <div class="flex-grow-1">
        <span class="fw-800">School: </span>
        <app-school-name [schoolId]="school.id" />
      </div>
      <i class="bi bi-x d-block"></i>
    </div>
  </ng-container>
  <ng-container *ngFor="let user of smartAssistantFeedFilters.userList">
    <div
      class="badge badge-item removable d-flex flex-row"
      (click)="removeFilterFromList('user_id', user)">
      <i class="bi bi-building me-1"></i>
      <div class="flex-grow-1">
        <span class="fw-800"> User: </span>{{ user.profile.first_name }}
        {{ user.profile.last_name }}
      </div>
      <i class="bi bi-x d-block"></i>
    </div>
  </ng-container>

  <div
    class="badge badge-item removable d-flex flex-row"
    *ngIf="
      smartAssistantFeedFilters.fromDate && smartAssistantFeedFilters.toDate
    "
    (click)="removeFilter('date')">
    <i class="bi bi-table me-1"></i>.
    <div class="flex-grow-1">
      <span class="fw-800"> Dates: </span>
      {{ smartAssistantFeedFilters.fromDate | formatNgbDate }}
      -
      {{ smartAssistantFeedFilters.toDate | formatNgbDate }}
    </div>
    <i class="bi bi-x d-block"></i>
  </div>
</div>
